import BannerPromotionsView from './_banner-promotions-view.js'

export default {
  name: 'BannerPromotions',
  values: {
    view: {
      configSet: BannerPromotionsView,
      configValues: {},
    },
    locationId: undefined,
    maxNumberOfPromotions: -1,
    reportLoadingStatus: false,
  },
  meta: {
    extendable: false,
  },
}
